import isWithinInterval from 'date-fns/isWithinInterval'
import parseISO from 'date-fns/parseISO'
import addDays from 'date-fns/addDays'
import childrenCategories from '../js/childrenCategories'

export default {
  latestProducts: (state) =>
    state.latestProducts.map((product) => {
      if (product.images.length > 0) {
        return { ...product, mainImage: product.images[0].picture }
      }
      return { ...product, mainImage: null }
    }),
  bestsellers: (state) =>
    state.bestsellers.map((product) => {
      if (product.images.length > 0) {
        return { ...product, mainImage: product.images[0].picture }
      }
      return { ...product, mainImage: null }
    }),
  products: (state) =>
    state.products.map((product) => {
      if (product.images.length > 0) {
        return { ...product, mainImage: product.images[0].picture }
      }
      return { ...product, mainImage: null }
    }),
  filters: (state) => ({
    perPage: state.pagination.perPage,
    orderBy: state.orderBy,
    orderByDirection: state.orderByDirection,
    category: state.route.params.category ? state.route.params.category : '',
  }),
  routeData: (state) => state.route.params,
  getLastChildrenCategories: (state) => {
    let categories = []
    const tree = state.categoriesTree
    categories = childrenCategories(tree)
    return categories
  },
  paginationLinks: (state) => {
    const links = []
    const { pagination } = state
    let start = 1
    let end = pagination.lastPage
    if (pagination.currentPage - pagination.linkRadius > 1) {
      links.push({ page: 1, class: 'pagination-link' })
      links.push({ page: '&hellip;', class: 'pagination-ellipsis' })
      start = pagination.currentPage - pagination.linkRadius + 1
    }
    let addEnd = false
    if (pagination.currentPage + pagination.linkRadius < end) {
      addEnd = true
      end = pagination.currentPage + pagination.linkRadius
    }
    for (let i = start; i <= end; i += 1) {
      links.push({
        page: i,
        class: `pagination-link${pagination.currentPage === i ? ' is-current' : ''}`,
      })
    }
    if (addEnd) {
      links.push({ page: '&hellip;', class: 'pagination-ellipsis' })
      links.push({ page: pagination.lastPage, class: 'pagination-link' })
    }
    return links
  },
  getParentCategory: (state) => (idCategory) => {
    const thisCategory = state.categories.find(
      (category) => category.id === idCategory,
    )
    return state.categories.find(
      (category) => category.id === thisCategory.parent_id,
    )
  },
  getChildrenCategories: (state) => (idCategory) => {
    const parentCategory = state.categories.find(
      (category) => category.id === idCategory,
    )
    return state.categories
      .filter(
        (category) =>
          category.lft > parentCategory.lft &&
          category.rgt <= parentCategory.rgt,
      )
      .map((category) => ({
        id: category.id,
        name: category.name,
        selected: false,
      }))
  },
  mainCategories: (state) =>
    state.categories.filter(
      (category) => category.parent_id === null || category.parent_id === 0,
    ),
  cartTotalPrice: (state) => {
    let total = 0
    const now = Date.now()
    state.cart.forEach((item) => {
      if (
        item.discountPrice &&
        isWithinInterval(now, {
          start: parseISO(item.discountPriceActiveFrom),
          end: addDays(parseISO(item.discountPriceActiveUntil), 1),
        })
      ) {
        if (state.user.discount) {
          const customerDiscountedPrice =
            (item.price * (100 - state.user.discount)) / 100
          total += customerDiscountedPrice * item.quantity
        } else {
          total += item.discountPrice * item.quantity
        }
      } else if (state.user.discount) {
        total +=
          ((item.price * (100 - state.user.discount)) / 100) * item.quantity
      } else {
        total += item.price * item.quantity
      }
    })
    return Math.round(total * 100) / 100
  },
  // Getter for cached product by slug
  getCachedProduct: (state) => (slug) => state.productsCache[slug],
}
